'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { GTMPageViewHandler } from '@/lib/analytics'

export default function GTMPageView() {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    useEffect(() => {
        if (pathname) {
            const url = `${pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`
            let payload = {
                page_path: pathname,
                page_search: searchParams?.toString() || '',
                page_url: url,
            }
            GTMPageViewHandler(payload)
        }
    }, [pathname, searchParams])
    return null
}